export default __webpack_public_path__ + "static/media/branding-blackitalic-webfont.671f1a4a.woff";